<template>
  <v-card>
    <v-card-text class="headline secondary--text pb-0">Seja bem vindo a Apetrus</v-card-text>
    <v-card-text
      class="subtitle-1 grey--text text--darken-2 pb-0"
    >Por favor, aguarde enquanto verificamos seu email</v-card-text>
    <v-card-text class="text-left">
      <v-progress-linear height="28" :value="percentage" rounded striped>
        <template v-slot="{ value }">
          <strong class="white--text">Completo: {{ Math.ceil(value) }}%</strong>
        </template>
      </v-progress-linear>
    </v-card-text>
    <v-slide-y-transition>
      <v-card-text class="pt-0 primary--text subtitle-1" v-if="percentage == 100">
        Verificação completa, você já pode começar a usar seu aplicativo
      </v-card-text>
    </v-slide-y-transition>
  </v-card>
</template>

<script>
export default {
  data () {
    return {}
  },
  computed: {
    percentage () {
      return this.$store.getters.percentage
    }
  }
}
</script>
